import { createBrowserRouter, createRoutesFromElements, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from '../pages/adminConsole/AdminLayout';
import { AdminLogin } from '../pages/adminConsole/AdminLogin';
import { Dashboard } from '../pages/adminConsole/Dashboard';
import { FeaturesManagement } from '../pages/adminConsole/FeaturesManagement';
import { FeatureDetails } from '../pages/adminConsole/FeatureDetails';
import { PlansManagement } from '../pages/adminConsole/PlansManagement';
import { PacksManagement } from '../pages/adminConsole/PacksManagement';
import { CouponsManagement } from '../pages/adminConsole/CouponsManagement';
import { UsersManagement } from '../pages/adminConsole/UsersManagement';
import { UserDetails } from '../pages/adminConsole/UserDetails';
import { RecruitersManagement } from '../pages/adminConsole/RecruitersManagement';
import { RecruiterDetails } from '../pages/adminConsole/RecruiterDetails';
import { Analytics } from '../pages/adminConsole/Analytics';
import { AuditLogs } from '../pages/adminConsole/AuditLogs';
import { CompaniesManagement } from '../pages/adminConsole/CompaniesManagement';
import { JobsManagement } from '../pages/adminConsole/JobsManagement';
import { LocationBackfill } from '../pages/adminConsole/LocationBackfill';
import { ExperienceDatesBackfill } from '../pages/adminConsole/ExperienceDatesBackfill';
import { ResumePdfAudit } from '../pages/adminConsole/ResumePdfAudit';
import { CrmLeads } from '../pages/adminConsole/CrmLeads';
import { ProductModules } from '../pages/adminConsole/ProductModules';
import { FeatureFlags } from '../pages/adminConsole/FeatureFlags';

function AdminProtectedRoute({ children }: { children: JSX.Element }) {
  const token = localStorage.getItem('admin_access_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

export const adminRoutes = createRoutesFromElements(
  <Route>
    <Route path="/admin/login" element={<AdminLogin />} />
    <Route
      path="/admin"
      element={
        <AdminProtectedRoute>
          <AdminLayout />
        </AdminProtectedRoute>
      }
    >
      <Route index element={<Dashboard />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="features" element={<FeaturesManagement />} />
      <Route path="features/:id" element={<FeatureDetails />} />
      <Route path="theresume-menu" element={<ProductModules />} />
      <Route path="feature-flags" element={<FeatureFlags />} />
      <Route path="pricing/plans" element={<PlansManagement />} />
      <Route path="pricing/packs" element={<PacksManagement />} />
      <Route path="pricing/coupons" element={<CouponsManagement />} />
      <Route path="users" element={<UsersManagement />} />
      <Route path="users/:id" element={<UserDetails />} />
      <Route path="recruiters" element={<RecruitersManagement />} />
      <Route path="recruiters/:id" element={<RecruiterDetails />} />
      <Route path="analytics" element={<Analytics />} />
      <Route path="audit-logs" element={<AuditLogs />} />
      <Route path="companies" element={<CompaniesManagement />} />
      <Route path="jobs" element={<JobsManagement />} />
      <Route path="location-backfill" element={<LocationBackfill />} />
      <Route path="experience-dates-backfill" element={<ExperienceDatesBackfill />} />
      <Route path="resume-pdf-audit" element={<ResumePdfAudit />} />
      <Route path="crm-leads" element={<CrmLeads />} />
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Route>
  </Route>
);

export const adminRouter = createBrowserRouter(adminRoutes);

